import { NgClass } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UsersService } from '@webapp/users/services/users.service';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '@webapp/ui';
@Component({
  selector: 'app-input-referral-code',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './input-referral-code.component.html',
  styleUrl: './input-referral-code.component.scss',
})
export class InputReferralCodeComponent {
  submitted = signal(false);
  isValidCode = signal(false);
  quoteId = input('');
  usersService = inject(UsersService);
  toastService = inject(ToastService);
  validReferrlCode = output<string>();
  form: FormGroup = new FormGroup({
    referralCode: new FormControl('')
  });
  showErrors(): boolean | undefined {
    const control = this.form.get('referralCode');
    return control?.enabled &&
      control?.invalid &&
      (control?.touched || control?.dirty || this.submitted());
  }


  async validateReferralCode(code: string) {
    const response = await firstValueFrom(this.usersService.validateReferralCode(code, this.quoteId()))
    if (response.valid) {
      this.validReferrlCode.emit(code);
      this.isValidCode.set(true);
    }else{
      this.form.get('referralCode')?.setValue('');
      this.toastService.showToast('Ocurrió un error', response.reason, 'error',);
    }
  }

  onSubmit() {
    this.submitted.set(true);
    if (!this.form.valid) return;
    const code = this.form.get('referralCode')?.value;
    if(!code) {
      this.toastService.showToast('Ocurrió un error', 'Debe ingresar un código', 'error',);
      return
    }
    this.validateReferralCode(code);

  }
}